import { useOutletContext } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';
import type { AppShellContext } from '@/components/layout/AppShell';
import { HrTabs } from '@/components/hr/HrTabs';
import { MyDataView } from '@/components/hr/MyDataView';
import { useHrMe } from '@/components/hr/useHrData';

/** HR "Moje dane": read-only kartoteka self view with PESEL-gated sensitive data. */
export function HrMyDataPage() {
  const { nip } = useOutletContext<AppShellContext>();
  const { hrMe, loading } = useHrMe(nip);

  if (loading) {
    return (
      <div className="flex flex-col gap-4">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-96 w-full" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <HrTabs nip={nip} hrMe={hrMe} />
      <MyDataView nip={nip} />
    </div>
  );
}
